import { render } from "./Cadeau.vue?vue&type=template&id=3d2d1efe"
import script from "./Cadeau.vue?vue&type=script&lang=js"
export * from "./Cadeau.vue?vue&type=script&lang=js"
script.render = render

export default script